import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useKidsStore from '../store/kidsStore';
import DailySummary from './DailySummary';
import Homework from './Homework';
import Timetable from './Timetable';
import Schedule from './Schedule';
import MathQuiz from './MathQuiz';
import Reading from './Reading';
import QuizHistory from './QuizHistory';

/** Back bar shown above a parent-managed kid screen. */
const Wrap: React.FC<{ kidId?: string; children: React.ReactNode }> = ({ kidId, children }) => {
  const navigate = useNavigate();
  return (
    <div className="space-y-3">
      <button onClick={() => navigate(`/parent/kids/${kidId}/learn`)}
        className="text-brand-blue font-bold text-sm flex items-center gap-1">← Back to kid</button>
      {children}
    </div>
  );
};

const useKidGrade = (kidId?: string): number | undefined => {
  const { kids, fetchKids } = useKidsStore();
  useEffect(() => { if (kids.length === 0) fetchKids(); }, [kids.length, fetchKids]);
  return kids.find((k) => String(k.id) === String(kidId))?.grade;
};

export const ParentKidSummary: React.FC = () => {
  const { kidId } = useParams();
  return <Wrap kidId={kidId}><DailySummary kidId={kidId} /></Wrap>;
};
export const ParentKidHomework: React.FC = () => {
  const { kidId } = useParams();
  return <Wrap kidId={kidId}><Homework kidId={kidId} /></Wrap>;
};
export const ParentKidTimetable: React.FC = () => {
  const { kidId } = useParams();
  return <Wrap kidId={kidId}><Timetable kidId={kidId} /></Wrap>;
};
export const ParentKidSchedule: React.FC = () => {
  const { kidId } = useParams();
  return <Wrap kidId={kidId}><Schedule kidId={kidId} /></Wrap>;
};
export const ParentKidMath: React.FC = () => {
  const { kidId } = useParams();
  const grade = useKidGrade(kidId);
  return <Wrap kidId={kidId}><MathQuiz kidId={kidId} kidGrade={grade} /></Wrap>;
};
export const ParentKidReading: React.FC = () => {
  const { kidId } = useParams();
  const grade = useKidGrade(kidId);
  return <Wrap kidId={kidId}><Reading kidId={kidId} kidGrade={grade} /></Wrap>;
};
export const ParentKidHistory: React.FC = () => {
  const { kidId } = useParams();
  return <Wrap kidId={kidId}><QuizHistory kidId={kidId} /></Wrap>;
};
